export const pictoDesigns = [
  {
    circles: [
      {
        left: 0,
        top: 0.5,
        size: 5,
        z: 3,
        color: '#ffe7c1',
      },
      {
        left: 2.5,
        top: 2,
        size: 4,
        z: 4,
        color: '#9dd6e4',
      },
    ],
    triangles: [],
  },
  {
    circles: [
      {
        left: 0,
        top: 2,
        size: 4,
        z: 3,
        color: '#ffe7c1',
      },
      {
        left: 3,
        top: 0,
        size: 3.5,
        z: 4,
        color: '#9dd6e4',
      },
      {
        left: 3.5,
        top: 3.5,
        size: 3,
        z: 3,
        color: '#e7d6d8',
      },
    ],
    triangles: [],
  },
  {
    circles: [
      {
        left: 2,
        top: 1.5,
        size: 5,
        z: 4,
        color: '#ffe7c1',
      },
      {
        left: 0,
        top: 1,
        size: 4,
        z: 3,
        color: '#9dd6e4',
      },
    ],
    triangles: [],
  },
  {
    circles: [
      {
        left: 0.5,
        top: 1,
        size: 5,
        z: 3,
        color: '#e7d6d8',
      },
    ],
    triangles: [
      {
        width: 4,
        height: 6,
        z: 4,
        left: 2.5,
        top: 0.5,
        color: 'transparent #9dd6e4 transparent transparent',
        rotate: 0,
      },
    ],
  },
  {
    circles: [
      {
        left: 0,
        top: 0.5,
        size: 2.5,
        z: 3,
        color: '#9dd6e4',
      },
      {
        left: 0.5,
        top: 2,
        size: 4.5,
        z: 3,
        color: '#ffe7c1',
      },
      {
        left: 3,
        top: 0.5,
        size: 3.5,
        z: 2,
        color: '#e7d6d8',
      },
    ],
    triangles: [],
  },
  {
    circles: [
      {
        left: 1,
        top: 1,
        size: 4.5,
        z: 3,
        color: '#9dd6e4',
      },
      {
        left: 4.25,
        top: 3.5,
        size: 3,
        z: 3,
        color: '#e7d6d8',
      },
    ],
    triangles: [
      {
        width: 3.5,
        height: 5,
        z: 2,
        left: 0,
        top: 1.5,
        color: 'transparent #ffe7c1 transparent transparent',
        rotate: 180,
      },
    ],
  },
];
